import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    kpiType = -1,
    industryId = '',
    depIds = [],
    pi = 1,
    ps = 50,
    order = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpi.searchPage, {
        search,
        kpiType,
        industryId,
        depIds,
        pi,
        ps,
        order,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, pi, ps };
};
